/** @class PaginationListMixin */

/** @method */
export var PaginationListMixin = function PaginationListMixin() {
  return "\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n    display: flex;\n    flex-flow: row;\n    align-items: center;\n";
};